<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <h2>水稻-葉稻熱病、穗稻熱病</h2>
    <div class="Info_Area">
      <b-container fluid>
        <div class="index-top-info">
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">檢查日期</label>
            <b-form-select
              id="inline-form-custom-select-pref"
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="yearselected"
              :options="yearlist"
              @change="TogetRiceBlastList()"
            ></b-form-select>
          </b-form>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-hover table-bordered">
            <thead class="text-center thead-dark">
              <tr>
                <th scope="col" style="width: 10%;">病蟲害</th>
                <th scope="col" colspan="12" class="bg-info">葉稻熱病</th>
                <th scope="col" colspan="12" class="bg-orange">穗稻熱病</th>
              </tr>
              <tr>
                <th scope="col" style="width: 10%;">調查地點/調查日期</th>
                <th scope="col" colspan="6" class="bg-info">豐收</th>
                <th scope="col" colspan="6" class="bg-info">菁埔</th>
                <th scope="col" colspan="6" class="bg-orange">豐收</th>
                <th scope="col" colspan="6" class="bg-orange">菁埔</th>
              </tr>
            </thead>
            <tbody style="text-align:center;">
              <tr
              v-for="(row,index) in displayedRows" :key="index"
              >
                <th scope="row" style="width: 10%;">{{row.S_DATE}}</th>
                <td scope="col" colspan="6">
                  <b-icon icon="circle-fill" animation="throb" variant="danger" v-if="row.S_HAR_4 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="warning" v-else-if="row.S_HAR_3 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" v-else-if="row.S_HAR_2 > 0" class="m-1 second-degree" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="success" v-else-if="row.S_HAR_1 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle" animation="throb" v-else class="m-1" font-scale="2"></b-icon>
                </td>
                <td scope="col" colspan="6"><!--row.S_CHI_1-->
                  <b-icon icon="circle-fill" animation="throb" variant="danger" v-if="row.S_CHI_4 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="warning" v-else-if="row.S_CHI_3 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" v-else-if="row.S_CHI_2 > 0" class="m-1 second-degree" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="success" v-else-if="row.S_CHI_1 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle" animation="throb" v-else class="m-1" font-scale="2"></b-icon>
                </td>
                <td scope="col" colspan="6"><!--S_HAR_1_2-->
                  <b-icon icon="circle-fill" animation="throb" variant="danger" v-if="row.S_HAR_3_2 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" v-else-if="row.S_HAR_2_2 > 0" class="m-1 second-degree" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="success" v-else-if="row.S_HAR_1_2 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle" animation="throb" v-else class="m-1" font-scale="2"></b-icon>
                </td>
                <td scope="col" colspan="6"><!--row.S_CHI_3_2-->
                  <b-icon icon="circle-fill" animation="throb" variant="danger" v-if="row.S_CHI_3_2 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" v-else-if="row.S_CHI_2_2 > 0" class="m-1 second-degree" font-scale="2"></b-icon>
                  <b-icon icon="circle-fill" animation="throb" variant="success" v-else-if="row.S_CHI_1_2 > 0" class="m-1" font-scale="2"></b-icon>
                  <b-icon icon="circle" animation="throb" v-else class="m-1" font-scale="2"></b-icon>
                </td>
              </tr>
            </tbody>
            <b-pagination
                v-show="totalRows > perPage"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
              >
              </b-pagination>
          </table>
        </div>

        <p>各罹病度標準警示燈號說明：
          <ol>
            <li class="mb-3">葉稻熱病：以目視法取該田區之平均值即為該區之葉病斑面積率。葉病斑面積率=(病斑面積/總葉面積) ×100%
              <ul class="list-unstyled">
                <li><b-icon icon="circle" class="mr-1"></b-icon>罹病度0級：葉病斑面積率為0%。</li>
                <li><b-icon icon="circle-fill" variant="success" class="mr-1"></b-icon>罹病度1級：葉病斑面積率&lt;5%。</li>
                <li><b-icon icon="circle-fill" class="mr-1 second-degree"></b-icon>罹病度2級：5% ≦葉病斑面積率&lt;11% 。</li>
                <li><b-icon icon="circle-fill" variant="warning" class="mr-1"></b-icon>罹病度3級：11% ≦葉病斑面積率&lt;55% </li>
                <li><b-icon icon="circle-fill" variant="danger" class="mr-1"></b-icon>罹病度4級：葉病斑面積率 ≧55%。</li>
              </ul>
            </li>
            <li>穗稻熱病：以目視法調查罹病穗數，以叢為單位，1穗中有3枝梗以上，或約1/5以上梗罹病者視為罹病穗，取該區田區之平均值即為該區之罹病穗率。罹病穗率=(罹病穗數/調查總穗數) ×100%</li>
            <ul class="list-unstyled">
              <li><b-icon icon="circle" class="mr-1"></b-icon>罹病度0級：罹病穗率為0%。</li>
              <li><b-icon icon="circle-fill" variant="success" class="mr-1"></b-icon>罹病度1級：罹病穗率&lt;5%。</li>
              <li><b-icon icon="circle-fill" class="mr-1 second-degree"></b-icon>罹病度2級：5% ≦罹病穗率&lt;20% 。</li>
              <li><b-icon icon="circle-fill" variant="danger" class="mr-1"></b-icon>罹病度3級：罹病穗率 ≧20%。</li>
            </ul>
          </ol>

        </p>
      </b-container>
    </div>
  </b-container>
</template>

<script>



export default {
  data() {
    return {
      perPage: 8,
      currentPage: 1,
      selection: [],
      totalRows: 1,
      isBusy: true,
      yearlist:[],
      yearselected:"請選擇年度",
      RiceBlastList:[],
      FilterRiceBlastList:[],
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "病蟲害資訊",
          active: true,
        }
      ],
      window: {
        width: 1024,
        height: 0,
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      showmanage: {
        maintain: false,
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      apiGetTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/getTradeWarningCrop", data),
      apiUpdateTradeWarningCrop: (data) =>
        this.userRequest.post("/API/Default/updateTradeWarningCrop", data),
      apiCropManagementList: (data) =>
        this.userRequest.post("/API/Default/CropManagementList", data),
      apiToRiceBlasYearList: (data) =>
        this.userRequest.post("/API/Default/ToRiceBlasYearList", data),
      apiRiceBlastList: (data) =>
        this.userRequest.post("/API/Default/RiceBlastList", data),
    };
  },
  // filterdata() {
  //   this.FilterRiceBlastList =this.RiceBlastList.filter( row =>  {
  //       return (row.S_HAR_2 !== 0 || row.S_HAR_3 !== 0 ||  row.S_HAR_4 !== 0 ||  row.S_HAR_5 !== 0) ||
  //           (row.S_CHI_2 !== 0 ||  row.S_CHI_3 !== 0 ||  row.S_CHI_4 !== 0 ||  row.S_CHI_5 !== 0) ||
  //           (row.S_HAR_2_2 !== 0 ||  row.S_HAR_3_2 !== 0 ||  row.S_HAR_4_2 !== 0 || row.S_HAR_5_2 !== 0) ||
  //           (row.S_CHI_2_2 !== 0 ||  row.S_CHI_3_2 !== 0 ||  row.S_CHI_4_2 !== 0 ||  row.S_CHI_5_2 !== 0)
  //     });
  // },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.checkPermission()
    this.getYearList();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    init() {
      //this.getCropManagementList();
      // this.priceanalysis.items = [...this.priceanalysis.allitems]
    },
    //取得年度清單
    getYearList(){
      console.log("getYearList call with mounted");
      this.apiToRiceBlasYearList()
      .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          this.yearlist=[];
          if (json.Status) {
            this.yearlist = jsonData;
            this.yearselected=this.yearlist[0];
            this.getRiceBlastList({year: this.yearselected});
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    TogetRiceBlastList(){
      this.getRiceBlastList({year: this.yearselected});
    },
    //取得病蟲害清單
    getRiceBlastList(data){
      this.apiRiceBlastList(data)
      .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.RiceBlastList = jsonData;
            this.isBusy = false;
            this.FilterRiceBlastList =this.RiceBlastList;
          //   this.FilterRiceBlastList =this.RiceBlastList.filter( row =>  {
          //   return (row.S_HAR_0 !== 0 || row.S_HAR_1 !== 0 || row.S_HAR_2 !== 0 || row.S_HAR_3 !== 0 ||  row.S_HAR_4 !== 0 ||  row.S_HAR_5 !== 0) ||
          //       (row.S_CHI_0 !== 0 || row.S_CHI_1 !== 0 || row.S_CHI_2 !== 0 ||  row.S_CHI_3 !== 0 ||  row.S_CHI_4 !== 0 ||  row.S_CHI_5 !== 0) ||
          //       (row.S_HAR_0_2 !== 0 ||  row.S_HAR_1_2 !== 0 ||  row.S_HAR_2_2 !== 0 ||  row.S_HAR_3_2 !== 0 ||  row.S_HAR_4_2 !== 0 || row.S_HAR_5_2 !== 0) ||
          //       (row.S_CHI_0_2 !== 0 ||  row.S_CHI_1_2 !== 0 ||  row.S_CHI_2_2 !== 0 ||  row.S_CHI_3_2 !== 0 ||  row.S_CHI_4_2 !== 0 ||  row.S_CHI_5_2 !== 0);
          // });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    settotalRows() {
      this.totalRows= this.FilterRiceBlastList.length;
    },
    getTradeWarningCrop(data) {
      this.apiGetTradeWarningCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.priceanalysis.items = jsonData;
            this.addcount();
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    valueParse(data) {
      // console.log(data);
      if (data == 0) return "-";
      return data;
    },
  },
  computed: {
    filreredRows(){
      return this.FilterRiceBlastList;
    },
    displayedRows(){
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filreredRows.slice(start, end);
    },
  },
  watch: {
    "RiceBlastList"(){
      this.settotalRows();
    }
  },
  components: {

  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
.date-panel {
  left: -5rem;
}
th, td {
  text-align: center;
}
.second-degree{
  color: #007bff;
}
</style>
